import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['panel']

    static values = {
        enter: 'transform ease-out duration-300 transition',
        enterFrom: 'translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2',
        enterTo: 'translate-y-0 opacity-100 sm:translate-x-0',
        leave: 'transition ease-in duration-100',
        leaveFrom: 'opacity-100',
        leaveTo: 'opacity-0'
    }

    connect() {
        this.show()
    }

    show() {
        setTimeout(this.dismiss.bind(this), 3000)
    }

    dismiss() {
        this.panelTarget.remove();

    }
}